export const state = () => ({
	word: "",
});

export const mutations = {
	open: (state, word) => (state.word = word),
	close: (state) => (state.word = ""),
};
